<div class="container" *ngIf="product">
    <mat-dialog-content class="mat-typography">

        <div class="px-2 text-center">
            <div class="alert alert-warning text-center" *ngIf="status == 'loading'">
                <div class="spinner-border text-primary text-center" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div class="alert alert-success" *ngIf="status == 'succes'">El producto se ha agregado correctamente</div>
            <div class="alert alert-danger" *ngIf="status == 'failed'">El producto no se ha podido agregar</div>
        </div>

        <form  [formGroup]="formProduct" (ngSubmit)="onSubmit(formProduct)">
            <div class="row">
                <div class="col-md-6 col-xs-12">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label class="w-100">Nombre</mat-label>
                        <input matInput type="text" formControlName="nombre">
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-xs-12">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label class="w-100">Categoría</mat-label>
                        <input matInput type="text" formControlName="categoria" [matAutocomplete]="auto">

                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{option.nombre}}
                          </mat-option>
                        </mat-autocomplete>

                    </mat-form-field>
                </div>
            </div>

            <mat-form-field class="w-100" appearance="fill">
                <mat-label class="w-100">Descripción</mat-label>
                <textarea matInput type="text" formControlName="descripcion"></textarea>
            </mat-form-field>

            <div class="row">
                <div class="col-md-6 col-xs-12">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label class="w-100">Costo $</mat-label>
                        <input matInput type="number" formControlName="costo">
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-xs-12">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label class="w-100">Precio $</mat-label>
                        <input matInput type="number" formControlName="precio">
                    </mat-form-field>
                </div>
            </div>

            <input type="submit" value="Enviar" class="btn btn-warning col-md-12 mt-4" name="" id=""
                [disabled]="formProduct.invalid" />

        </form>
    </mat-dialog-content>
</div>